import { NavLink, Outlet, useNavigate, Navigate } from 'react-router-dom';
import { LayoutDashboard, Users, FileCheck, Flag, LogOut, Loader2, KeyRound } from 'lucide-react';
import { useAdminAuth } from '../../lib/AdminAuthContext';

const NAV = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true, testid: 'admin-nav-dashboard' },
  { to: '/admin/users', label: 'Users', icon: Users, testid: 'admin-nav-users' },
  { to: '/admin/submissions', label: 'Submissions', icon: FileCheck, testid: 'admin-nav-submissions' },
  { to: '/admin/reports', label: 'Reports', icon: Flag, testid: 'admin-nav-reports' },
  { to: '/admin/security', label: 'Security', icon: KeyRound, testid: 'admin-nav-security' },
];

export default function AdminLayout() {
  const { admin, loading, logout } = useAdminAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="min-h-screen bg-[#0D0B12] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#C8553D]" /></div>;
  }
  if (!admin) return <Navigate to="/admin/login" replace />;

  function handleLogout() { logout(); navigate('/admin/login'); }

  return (
    <div className="min-h-screen flex bg-[#0D0B12]" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-60 bg-[#1A1820] border-r border-white/10 flex flex-col">
        <div className="px-6 py-5 border-b border-white/10 flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-white flex items-center justify-center overflow-hidden">
            <img src="/logo.jpg" alt="AfroConnect" className="w-7 h-7 object-contain" />
          </div>
          <div>
            <p className="text-white font-bold text-sm">Admin Console</p>
            <p className="text-white/40 text-[10px] uppercase tracking-wider">{admin.role || 'admin'}</p>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map(({ to, label, icon: Icon, end, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold transition-colors ${
                  isActive ? 'bg-[#C8553D] text-white' : 'text-white/70 hover:bg-white/5'
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <p className="px-3 py-1 text-xs text-white/50 truncate" data-testid="admin-current-email">{admin.email}</p>
          <button onClick={handleLogout} data-testid="admin-logout-button" className="mt-1 w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-semibold text-white/70 hover:bg-white/5 hover:text-[#E07A5F]">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
